import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getAllIM_INV = () => {
  return httpClientImmigration.get(server.IM_INV + `/`);
};

export const CreateIM_INV = (data) => {
  return httpClientImmigration.post(server.IM_INV, data);
};

export const updateIM_INV = (id, data) => {
  return httpClientImmigration.put(server.IM_INV + `/${id}`, data);
};

export const DeleteIM_INV = (id) => {
  return httpClientImmigration.delete(server.IM_INV + `/${id}`);
};
